import { css } from 'react-emotion'

const styles = {
  header: css({
    userSelect: 'none',
    padding: '0 32px',
    paddingTop: '0'
  }),
  seperator: css({
    display: 'inline-block',
    margin: '0 8px'
  }),
  viewContainer: css({
    borderTop: '3px solid #f4f4f6',
    padding: '24px',
    height: 'calc(100% - 116px)',
    position: 'relative',
    overflow: 'hidden'
  }),
  videoList(isSettingsDisplay, isSideBarVisible) {
    const style = {
      // display: 'block',
      height: '100%',
      overflow: 'auto',
      paddingBottom: '20px'
    }
    if (isSettingsDisplay) {
      style.display = 'none'
    }
    if (isSideBarVisible && window.screen.width > 991) {
      style.paddingRight = '260px'
    }
    return css(style)
  },
  rightSideBar(isSettingsDisplay, isSideBarVisible) {
    let style = {
      position: 'absolute',
      top: '0',
      bottom: '0',
      right: '0',
      left: 'calc(100% - 260px)',
      background: '#fff',
      zIndex: '222',
      borderLeft: '1px solid #f4f4f6',
    }
    if (!isSideBarVisible || isSettingsDisplay) {
      style = { display: 'none' }
    }
    return css(style)
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Home/ProjectDashboardStyles.js